export const overlijdenMeldenNl = {
  OverlijdenMeldenFormulierStapGegevensOverledene: "Gegevens overledene"
};
